/**
 * Created by Ninghai on 2017/12/22.
 */
import doRequest from './fetch'
import {
  LOGIN_API_URL,
  TOKEN_API_URL,
  RECOVER_PASSWORD_API_URL,
  SIGNUP_API_URL,
  SIGNUP_API1_URL,
  LOGOUT_API_URL,
  REST_PASSWORD_API_URL,
  GET_USER_INFOR_API_URL,
  OCS_COMPANY_COMPUTED_URL,
  UPDATE_USER_INFO,
  COMPANY_LIST_API_URL,
  USER_APPLY_DATA_API_URL,
  USER_APPLY_DATA_LIST_API_URL,
  USER_APPLY_DATA_LIST_COUNT_API_URL,
  UNLISTED_COMPANY_DETAIL_INFO_API_URL,
  UNLISTED_COMPANY_DETAIL_DATA_API_URL,
  UNLISTED_COMPANY_DETAIL_DATALIST_API_URL,
  MENU_LIST_DATA_API_URL,
  INDUSTRY_DATA_API_URL,
  PRODUCT_DATA_API_URL,
  ENTERPRISE_DATA_API_URL,
  ASHARE_LATEST_RECORD_DATE_API_URL,
  ASHARE_MENU_MATRIX_LOOCK,
  LATEST_RECORD_DATE_API_URL,
  CHARGE_API_URL,
  UNLISTED_COMPANY_PAY_INFO_API_URL,
  ASHARE_ORDER_API_URL,
  ORDER_API_URL,
  VISITOR_FEEDBACK_API_URL,
  SENTIMENT_LIST_API_URL,
  SENTIMENT_GROWTH_LIST_API_URL,
  HOT_LIST_API_URL,
  HOT_GROWTH_LIST_API_URL,
  STOCK_SENTIMENT_API_URL,
  STOCK_HOT_API_URL,
  MAOTAI_DATA_API_URL,
  COMPANY_SUM_INFO_URL,
  OCS_COMPANY_SUMMARY_URL,
  TMALL_JD_DATA_URL,
  MOMO_DATA_URL,
  KL_YANXUAN_DATA_URL,
  YY_HUYA_DATA_URL,
  OCS_PURCHASE_DATA_URL,
  vagueSeaechUrl, // A股模糊搜索
  newCompanyInfo,
  pinduoduoUrl, // 中概股拼多多数据
  newCategoryInfo,
  newAshresMuenu, // java接口A股
  newIndustryMessage, // java行业信息
  emotionParameter,
  emotionDetailsUrl,
  retailersUrl,
  newCompanyListMuenu,
  liveUrl,
  downloadUrl, // 下载url
  topLiveUrl, // 直播上面那个横条的数据
  dataDownURL, // 数据下载接口
  dataBrandUrl, // 品牌馆
  dataExpressUrl, // 首页 数据快讯
  dataInfoUrl, // 15万天猫一级导航
  dataListUrl, // 15万 列表
  dataSelectUrl, chatGPTUrl,chatGPTUrl1,chatGPTUrl3,chatGPTUrl4// 15万 下拉框
} from './serviceConstant'

export const jobList = () => {
  let list = [{
    carrier: '信息安全工程师',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['负责搭建网络爬虫的底层设施，针对不同的反爬策略，设计统一的反反爬方案。'],
    skill: ['了解操作系统原理，熟悉LINUX、Android系统调用和API函数', '了解TCP/IP协议原理，熟悉LINUX内核中TCP/IP协议栈的更佳', '熟悉信息安全专业知识，有较扎实的密码学理论基础，了解常用加密算法，并能独立完成相关编程工作', '熟悉python, java, shell, C等编程语言，和tcpdump, wireshark, fidller等常用协议分析工具', '两年以上B/S架构开发经验，熟悉B/S、C/S架构和通信编程模型']
  }, {
    carrier: 'Python工程师',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['和算法工程师对接，集成自然语言处理算法，提供后端接口', '公司SAAS数据平台后端接口的开发', '知识图谱相关后端平台的建设及数据接口的开发'],
    skill: ['精通Python语言，精通数据结构', '精通flask、Tornado等框架，注重代码质量和可维护性', '熟悉Nginx、uWSGI', '熟悉数据库知识，熟悉redis，mongodb，mysql', '具有扎实的服务器端开发功底，对数据结构和算法有深刻理解']
  }, {
    carrier: '爬虫工程师',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['研究各种网页、app接口，探寻特点和规律', '编写抓取互联网内容的爬虫', '研究优化算法，提升爬虫系统的稳定性、可扩展性', '攻破各种反爬虫'],
    skill: ['计算机、电子、通信、物理、数学等相关理工科专业', '有二年以上编程开发经验', '精通Python，掌握爬虫技术，熟悉scrapy框架、pyspider框架等', '有丰富的反爬虫经验者优先', '有数据分析经验者优先', '熟悉至少一种Sql数据库 （mysql/postgresql/sqlserver/oracle/db2），了解至少一种Nosql数据库（redis, memcache, mongodb, hbase）', '热爱数据分析，对从数据中发掘出有价值的信息充满热情，踏实、主动，有较强的学习能力']
  }, {
    carrier: '爬虫技术专家',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['负责公司分布式抓取平台的核心技术研发。通过逆向相关的安全攻防战，实现反爬对抗。通过对抓取、解析、调度、存储等模块的拆分与优化，构建和完善统一的抓取服务平台。'],
    skill: ['211、985高校本科以上学历，计算机、物理、数学、统计、电子等理工科专业', '2年以上互联网公司相关工作经验', '熟悉常用编程语言，包括Java、Python等', '对数据结构和算法设计有较为深刻的理解', '对网络通信、TCP协议有将为深入的理解', '有安全攻防背景、逆向分析、渗透测试经验优先', '对浏览器内核有一定了解者优先', '有大型爬虫系统研发经验者优先']
  }, {
    carrier: '算法工程师(NLP)',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['针对海量互联网数据，进行文本内容抽取、中文分词、语义识别、自动文本聚类、主题模型、情感分析等文本挖掘的工作', '通过文本挖掘，发现影响上市公司股价变动的因子'],
    skill: ['对基于文本的量化金融方向有浓厚的兴趣', '掌握一定的自然语言处理的算法和技术', '精通常用数据结构和算法', '计算机、物理、数学等相关专业，有主题模型、机器学习、深度学习、正文抽取、hadoop/Spark经验者优先', '扎实的编码能力，精通Python语言开发, 熟练使用linux下的C/C++', '对算法有很高的热情，渴望用算法解决商业世界的难题']
  }, {
    carrier: '大数据研发工程师',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['通过互联网抓取各类量化、文本数据', '采用大数据计算框架、机器学习算法等对抓取到的数据进行深入分析', '设计、优化量化金融数据产品'],
    skill: ['211、985高校计算机、电子、物理、数学等相关理工科专业本科以上学历', '熟练掌握python/SQL', '熟悉Linux/Unix环境，shell编程等', '熟悉至少一种开发语言，如Python、C/C++、Java等', '熟悉至少一种数据库，如Oracle、MySQL、Mongodb等', '熟悉redis、memcached等分布式缓存系统', '有互联网公司运维经验优先']
  }, {
    carrier: '大数据计算平台技术总监',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['组织工程团队开发大规模网络页面数据抓取和维护的自动化系统 ', '开发海量数据分布式计算平台，负责平台的系统架构设计', '研发数据挖掘模型，对接业务团队，搭建实时的数据洞察系统'],
    skill: ['计算机，电子工程，统计，数学，理论物理专业，硕士以上学位，海外教育背景或中国名校毕业，Ph.D. 学位优先，知名互联网企业从业经验优先', '有大规模数据采集和计算 3-5年经验，有分布式系统架构经验，有软件工程3-5年经验，代码能力扎实', '有机器学习和深度学习扎实的理论和实践功底，熟悉大规模GPU集群架构，熟悉NLP领域相关算法 ', '具有带领团队处理复杂问题能力，具有强大技术攻关的能力和热情', '热爱运动']
  }, {
    carrier: '大数据、机器学习系统架构师',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['根据公司海量数据处理的需求，从架构层面设计并完善现有的大数据、机器学习平台，并带领团队进行平台架构的迭代升级和优化'],
    skill: ['211、985硕士以上学历，计算机、物理、数学、统计、电子等理工科专业', '5年以上互联网公司相关工作经验，3年以上大数据、机器学习系统分析、架构设计、开发经验', '精通大数据生态圈的技术，包括但不限于MapReduce、Spark、Hadoop、Kafka、Mongodb、Redis、Flume、Storm、Hbase、Hive，具备源码级问题解决和集群优化改造能力', '熟悉常见的机器学习算法，熟悉常用的机器学习工具，包括但不限于Tensorflow、Sklearn、Caffe等，有实际分析模型开发、训练经验', '熟悉常用编程语言，包括Java、Python、Scala等', '具有很强的技术研发和创新能力，能有效把握技术发展方向，有较强的执行能力、学习能力、沟通能力、适应能力，责任心强', '有创业热情，期望与创业公司共同成长']
  }, {
    carrier: '金融数据产品销售',
    cate: '销售类',
    addr: '北京',
    time: '2018-04-12',
    content: ['管理总体咨询销售流程，包括：金融数据市场竞争格局研究、挖掘潜在商业机会、接触潜在客户、业务发展及成功完成销售', '描述、区分及定位公司的金融数据产品的价值', '制造销售演示材料及内容', '与客户端决策者及具备影响力者建立、管理及维护关系', '主动预测客户需求并适当调整销售方式', '通过不断提高对产品的知识建立及培养客户的信誉', '为客户提供持续的售后服务及沟通'],
    skill: ['具有2-5 年在二级市场金融机构，基金市场内销售数据产品的经验', '曾在Bloomberg, Reuters 负责金融数据产品销售的优先', '对金融行业二级市场使用的投资方法有深度的理解', '有很强抗压能力，解决困难的能力，具有进攻性性格', '具有高度主动力及信心的销售方法及策略', '优秀的沟通及表达能力', '需常出差']
  }, {
    carrier: 'marketing 总监',
    cate: '技术类',
    addr: '北京',
    time: '2018-04-12',
    content: ['根据公司战略方向，制定市场部门的战略规划', '制定和实施市场部门的年度计划', ' 制定超对称技术的技术品牌策略和金融品牌策略', '建立金融领域和科技媒体资源管理体系', ' 金融和人工智能领域的论坛活动，展览活动的策划和执行', '组建市场团队，制定绩效考评体系'],
    skill: ['3年以上金融和互联网技术型企业，或者科技媒体的市场营销经验', '热爱跨学科阅读，追踪前沿技术发展趋势，热爱科学新知识的探索', '海外名校，中国985/211学校毕业', '优秀的沟通协调能力，擅长多部门协作', '优秀的学习能力和时刻开放的心态；优秀领导能力，掌握管理团队的基础技能.']
  }, {
    carrier: '人力资源专员',
    cate: '人力资源',
    addr: '北京',
    time: '2018-04-12',
    content: ['负责公司招聘和人才搜索', '完成公司制定的招聘任务', '招聘效率分析，招聘渠道管理', '建立和完善公司的招聘流程和招聘体系', '建立后备人才选拔方案和人才储备机制'],
    skill: ['全日制本科学历以上，互联网公司1年以上技术岗招聘经验，有猎头工作经验优先 ', '有良好的职业敏感度及判断力，有较强的亲和力及团队合作精神，有良好的人际关系处理能力', '有独立工作能力，自驱力，能抗压', '有校招经验优先', '阅读和书写能力出色或有第二外语能力优先']
  }, {
    carrier: '人力资源专经理',
    cate: '人力资源',
    addr: '北京',
    time: '2018-04-12',
    content: ['负责参与公司人力资源的总体规划及发展，对整体人力资源体系进行优化，包括 招聘、薪酬、绩效、员工关系、培训等各项工作与HR团队管理', '协调公司各部门关系，建立上下级员工沟通渠道，更好发挥员工积极能动性', '向高层决策者提供有关人力资源战略、组织建设等方面的建议；合理利用人力资源成本，提高公司整体的综合管理水平'],
    skill: ['全日制本科学历以上，211/985优先', '在知名科技互联网公司做过3-5年HR优先', '阅读和书写能力出色，有第二外语能力优先，有海外留学经历优先', '有会计或人力资源专业背景优先', '热爱阅读，热爱学习各领域交叉学科知识，知识面广', '反应敏捷，勤奋，有良好团队合作能力']
  }]
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(list)
    }, 200)
  })
}
// 原python接口
// export const sendLogin = (username, password) => doRequest({
//   method: 'PUT',
//   url: LOGIN_API_URL,
//   data: {username, password}
// })
export const sendLogin = (username, password) => doRequest({
  method: 'POST',
  url: LOGIN_API_URL,
  data: {username, password}
})
export const getToken = () => doRequest({
  method: 'GET',
  url: TOKEN_API_URL,
  data: {}
})

// eslint-disable-next-line
export const recoverPassword = (email, photo_code, token) => doRequest({
  method: 'PUT',
  url: RECOVER_PASSWORD_API_URL,
  data: {email, photo_code, token}
})

export const sendSmsVerifyCode = (credential, url) => doRequest({
  method: 'PUT',
  url: url,
  data: credential
})

export const signUp = (credential) => doRequest({
  method: 'POST',
  url: SIGNUP_API_URL,
  data: credential
})
export const signUp_api = (credential) => doRequest({
  method: 'POST',
  url: SIGNUP_API1_URL,
  data: credential
})

export const logout = () => doRequest({
  method: 'POST',
  url: LOGOUT_API_URL
})

// userInfo
// eslint-disable-next-line
export const resetPassword = (password, new_password) => doRequest({
  method: 'POST',
  url: REST_PASSWORD_API_URL,
  data: {password, new_password}
})

export const getUserInfo = () => doRequest({
  method: 'POST',
  url: GET_USER_INFOR_API_URL
})

export const updateUserInfo = ({name, companyName, mobile}) => doRequest({
  method: 'POST',
  url: UPDATE_USER_INFO,
  data: {name, companyName, mobile}
})

export const getCompanyList = ({start, type, str, limit = 10}) => doRequest({
  method: 'GET',
  url: COMPANY_LIST_API_URL,
  params: {start, str, type, limit}
})

export const applyData = ({company, requirement, type}) => doRequest({
  method: 'POST',
  data: {company, requirement, type},
  url: USER_APPLY_DATA_API_URL
})

export const applyDataLList = (type, start, limit) => doRequest({
  method: 'GET',
  url: USER_APPLY_DATA_LIST_API_URL,
  params: {
    type,
    start,
    limit
  }
})

export const appliDataListCount = (type) => doRequest({
  method: 'GET',
  url: USER_APPLY_DATA_LIST_COUNT_API_URL,
  params: {
    type
  }
})

export const updateData = ({company, requirement, apply_id}) => doRequest({
  method: 'PUT',
  url: USER_APPLY_DATA_API_URL,
  data: {
    company,
    requirement,
    apply_id
  }
})

// A 股 数据获取
export const menuList = () => doRequest({
  method: 'GET',
  url: MENU_LIST_DATA_API_URL
})

export const getIndustryInfo = (industryId) => doRequest({
  method: 'GET',
  url: INDUSTRY_DATA_API_URL,
  params: {
    id: industryId
  }
})

export const getIndustrySplitedInfo = (industryId, start, limit) => doRequest({
  method: 'GET',
  url: INDUSTRY_DATA_API_URL,
  params: {
    id: industryId,
    start: start || 0,
    limit: limit || 10
  }
})

export const getEnterpriseInfo = (enterpriseId, type, start, end) => doRequest({
  method: 'POST',
  url: ENTERPRISE_DATA_API_URL,
  data: { id: enterpriseId, type: type, start: start, end: end }
})

export const getProductInfo = (enterprise, brand, product, start, end) => doRequest({
  method: 'POST',
  url: PRODUCT_DATA_API_URL,
  data: {enterprise, brand, product, start, end}
})

export const getAshareLatestRecordDate = (product) => {
  let date = new Date()
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate())
    }, 0)
  })
}
export const getAshareLatestRecordDateReal = (brand, product) => doRequest({
  method: 'GET',
  url: ASHARE_LATEST_RECORD_DATE_API_URL,
  params: {brand, product}
})

export const getMenuMatrixLock = () => doRequest({
  method: 'GET',
  url: ASHARE_MENU_MATRIX_LOOCK
})
export const buyAshareData = () => doRequest({
  method: 'POST',
  url: ASHARE_ORDER_API_URL,
  data: {}
})

// 未上市公司数据
export const getUnlistedEnterpriseInfo = (id) => doRequest({
  method: 'GET',
  url: UNLISTED_COMPANY_DETAIL_INFO_API_URL,
  params: {
    id: id
  }
})

export const getUnlistedEnterpriseDatabyDate = (id, date) => doRequest({
  method: 'GET',
  url: UNLISTED_COMPANY_DETAIL_DATA_API_URL,
  params: {
    id: id,
    date: date
  }
})

export const getUnlistedEnterpriseDataByRange = (id, start, end) => doRequest({
  method: 'GET',
  url: UNLISTED_COMPANY_DETAIL_DATALIST_API_URL,
  params: {
    id: id,
    start: start,
    end: end
  }
})

export const getYYHuyaData = ({id, start, end}) => doRequest({
  method: 'GET',
  url: YY_HUYA_DATA_URL.replace('@id', id),
  params: {
    start,
    end
  }
})

export const getCompanySumary = (id) => doRequest({
  method: 'GET',
  url: COMPANY_SUM_INFO_URL,
  params: {id}
})

export const getCompanySumaryData = (params, id) => doRequest({
  method: 'GET',
  url: OCS_COMPANY_SUMMARY_URL.replace('@id', id),
  params
})

export const getComponayComputed = (params, id) => doRequest({
  method: 'GET',
  url: OCS_COMPANY_COMPUTED_URL.replace('@id', id),
  params
})

export const getTmallJdData = (data) => doRequest({
  method: 'POST',
  url: TMALL_JD_DATA_URL,
  data
})

export const getMomoData = ({id, date, start, end, queryType}) => {
  let type = 'byDate'
  let body = { id, date }
  if (queryType !== 'day') {
    type = 'byRangeDate'
    body = { id, start, end }
  }
  return doRequest({
    method: 'POST',
    url: MOMO_DATA_URL.replace('@id', id).replace('@type', type),
    data: body
  })
}

export const getKlYanxuanData = (params) => doRequest({
  method: 'GET',
  url: KL_YANXUAN_DATA_URL,
  params
})

export const getUnlistedLastedDataRecord = (id) => doRequest({
  method: 'GET',
  url: LATEST_RECORD_DATE_API_URL,
  params: {id: id}
})

export const buyOcsData = () => doRequest({
  method: 'POST',
  url: OCS_PURCHASE_DATA_URL,
  data: {}
})

export const getUnlistedEnterprisePayInfo = (id) => doRequest({
  method: 'GET',
  url: UNLISTED_COMPANY_PAY_INFO_API_URL,
  params: { id }
})

export const buyData = (paramsObj) => doRequest({
  method: 'POST',
  url: ORDER_API_URL,
  data: paramsObj
})

// 充值
export const chargeInfo = ({channel, amount}) => doRequest({
  method: 'POST',
  data: {channel, amount},
  url: CHARGE_API_URL
})
export const getChargeInfo = ({id}) => doRequest({
  method: 'GET',
  url: CHARGE_API_URL,
  params: {id}
})

export const sendVistorFeedBack = (obj) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, 100)
  })
}
export const sendVistorFeedBackReal = ({ message, name, phone, email }) => doRequest({
  method: 'POST',
  url: VISITOR_FEEDBACK_API_URL,
  data: { message, name, phone, email }
})

// 情绪指数模块
export const getSentimentListBySort = (sort = 1, amount = 20) => doRequest({
  method: 'POST',
  url: SENTIMENT_LIST_API_URL,
  data: {amount, sort}
})

export const getSentimentGrowthListBySort = (sort = 1, amount = 10) => doRequest({
  method: 'POST',
  url: SENTIMENT_GROWTH_LIST_API_URL,
  data: {amount, sort}
})

export const getHotListBySort = (sort = 1, amount = 20) => doRequest({
  method: 'POST',
  url: HOT_LIST_API_URL,
  data: {amount, sort}
})

export const getHotGrowthListBySort = (sort = 1, amount = 10) => doRequest({
  method: 'POST',
  url: HOT_GROWTH_LIST_API_URL,
  data: {amount, sort}
})

export const getStockSentiment = (enterpriseId, amount = 15) => doRequest({
  method: 'POST',
  url: STOCK_SENTIMENT_API_URL,
  data: {enterprise_id: enterpriseId, amount}
})

export const getStockHot = (enterpriseId, amount = 15) => doRequest({
  method: 'POST',
  url: STOCK_HOT_API_URL,
  data: {enterprise_id: enterpriseId, amount}
})

// API
export const getApiLog = () => {
  let log = [
    {content: '域名修改', date: '2018-03-27', detail: '所有API访问的域名从"https://beta.ssymmetry.com/api" 修改为"https://api.ssymmetry.com/api"'},
    {content: '品牌⽇度信息接⼝调整(该接⼝已于2018年4⽉28⽇移除)', date: '2018-03-27', detail: '品牌⽇度数据接⼝相应信息在第6号索引位新增数据来源信息, 1表示天猫, 0表示淘宝。'},
    {content: '新增品牌日度销售额接口', date: '2018-04-28', detail: '新增提供指定品牌指定⽇期的淘宝/天猫总销售额的接⼝。'},
    {content: '移除品牌⽇度信息接⼝', date: '2018-04-28', detail: ''}]
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(log)
    }, 1)
  })
}

// 茅台数据
export const getMaoTaiData = () => doRequest({
  method: 'POST',
  url: MAOTAI_DATA_API_URL
})

// 公司模糊搜索
export const getVagueCompany = (data) => doRequest({
  method: 'POST',
  url: vagueSeaechUrl,
  data: data
})
// 获取天级数据
export const getNewCompanyInfo = (data) => doRequest({
  method: 'POST',
  url: newCompanyInfo,
  data: data
})

export const getPinduoduoData = (data) => doRequest({
  method: 'POST',
  url: pinduoduoUrl,
  data: data
})
// java接口获取新的数据
export const getnewCategoryInfo = (id, bid, type, startDate, endDate) => doRequest({
  method: 'POST',
  url: newCategoryInfo,
  data: { id, bid, type, startDate, endDate }
})
// java接口回去A股分类和下属公司
export const getNewCompanyListMuenu = data => doRequest({
  method: 'POST',
  url: newCompanyListMuenu,
  data: data
})
// java接口获取行业信息
export const getNewIndustryMessage = data => doRequest({
  method: 'POST',
  url: newIndustryMessage,
  data: data
})

/**
 * 情绪因子部分
 */
// 获取参数
export const getEmotionParameter = data => doRequest({
  method: 'GET',
  url: emotionParameter
})
export const getEmotionDetails = (data) => {
  return doRequest({
    method: 'POST',
    url: emotionDetailsUrl,
    data: data
  })
}

/**
 * 电商标准化
 */
export const getRetailers = data => doRequest({
  method: 'POST',
  url: retailersUrl,
  data: data
})
/**
 * 直播标准化
*/
export const getlive = data => doRequest({
  method: 'POST',
  url: liveUrl,
  data: data
})

export const download = data => doRequest({
  method: 'POST',
  url: downloadUrl,
  data: data
})

export const getTopLive = data => doRequest({
  method: 'POST',
  url: topLiveUrl,
  data: data
})

// 数据下载-列表
export const getDataDown = data => doRequest({
  method: 'POST',
  url: dataDownURL,
  data: data
})

// 品牌馆
export const getBrand = data => doRequest({
  method: 'POST',
  url: dataBrandUrl,
  data: data
})

// 首页
export const getExpress = data => doRequest({
  method: 'POST',
  url: dataExpressUrl,
  data: data
})

// 15万 天猫-----start
// 左侧导航
export const getDataInfo = data => doRequest({
  method: 'POST',
  url: dataInfoUrl,
  data: data
})
// 列表
export const getDataList = data => doRequest({
  method: 'POST',
  url: dataListUrl,
  data: data
})
// 下拉框
export const getDataSelect = data => doRequest({
  method: 'POST',
  url: dataSelectUrl,
  data: data
})
// 15万 天猫-----end

export const getGptTalk = data => doRequest({
  method: 'POST',
  url: chatGPTUrl,
  data: data
})
export const getGptTalk1 = data => doRequest({
  method: 'POST',
  url: chatGPTUrl1,
  data: data
})
export const getGptTalk3 = data => doRequest({
  method: 'POST',
  url: chatGPTUrl3,
  data: data
})
export const getGptTalk4 = data => doRequest({
  method: 'POST',
  url: chatGPTUrl4,
  data: data
})



// WEBPACK FOOTER //
// ./src/services/getData.js